// 表单验证
const IDENTITY = {
  // 邮箱正则
  mailReg: /^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/,
  // 手机号正则
  phoneReg: /^1[0-9]{10}$/,
  // 营业执照正则
  certReg: /^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$/,
  // 邮箱验证
  identityMail: function (v) {
    return this.mailReg.test(v);
  },
  // 手机验证
  identityPhone: function (v) {
    return this.phoneReg.test(v);
  },
  // 营业执照验证
  identityCert: function (v) {
    return this.certReg.test(v);
  }
};

export default IDENTITY;